import styled from 'styled-components';

export const Grid = styled.div`
  display: flex;
  padding-top: 66px;
  background: ${props => props.theme.colors.bgContent};
  justify-content: center; /* AQUI */

  /* MOBILE */
  @media (max-width: 768px) {
    padding-top: 16px;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 0;
    background: -webkit-gradient(linear,left top,left bottom,from(${props => props.theme.colors.primary}),to(${props => props.theme.colors.primary}50));
    box-shadow: inset 2px 2px 2px rgba(255,255,255,.25), inset -2px -2px 2px rgba(0,0,0,.25);}

  ::-webkit-scrollbar-track {
    background-color: #fff;
    background: ${props => props.theme.colors.bgBox}80;
  }
`;
